import "../styles/AlertWidget.css";

function fmtTime(date) {
  if (!date) return "—";
  return date.toLocaleTimeString("en-IN", {
    hour: "2-digit", minute: "2-digit", second: "2-digit",
  });
}

export default function AlertWidget({ firingCustomers, lastUpdated }) {
  return (
    <div className="aw-root">
      {firingCustomers.length === 0 ? (
        <div className="aw-allclear">
          <span className="aw-allclear__dot" />
          All Clear
        </div>
      ) : (
        <div className="aw-tiles">
          {firingCustomers.map(t => (
            <div key={t.name} className="aw-tile">
              <div className="aw-tile__name" title={t.name}>{t.name}</div>
              <div className="aw-tile__count">{t.firing}</div>
              <div className="aw-tile__label">firing</div>
              {t.resolved > 0 && (
                <div className="aw-tile__resolved">{t.resolved} resolved</div>
              )}
            </div>
          ))}
        </div>
      )}
      <div className="aw-footer">
        <span className="aw-footer__dot" />
        {fmtTime(lastUpdated)}
      </div>
    </div>
  );
}
